'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';

/**
 * The Agent Receptionist chat widget (our own, from contactcenterhq.com).
 *
 * The widget already refuses to render on these prefixes — it reads
 * `data-excluded-prefixes` and no-ops — but the 21 KB script was still being
 * requested on every one of them, and the knowledge base is by far the largest
 * surface on the site. When a visitor's blocker or DNS filter kills the request
 * the load fails, which the GlitchReplay resource-error probe reports; that was
 * ~1,160 events for a script that had nothing to do on those pages anyway
 * (GlitchReplay 3d3b727b54204655).
 *
 * So do the exclusion check before the <Script> is rendered at all. This list is
 * the single source of truth: it is also what gets serialised into
 * `data-excluded-prefixes`, so the two can't drift. It only ever suppresses the
 * widget where the widget would already have suppressed itself.
 */
const EXCLUDED_PREFIXES = ['/tools/', '/knowledge-base/', '/glossary/', '/embed/'];

export default function ContactCenterWidget() {
  const pathname = usePathname();

  if (pathname && EXCLUDED_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
    return null;
  }

  return (
    <Script
      id="contactcenterhq-widget"
      src="https://embed.contactcenterhq.com/embed/widget.js"
      strategy="afterInteractive"
      data-tenant="inventive-hq"
      data-agent="susan"
      data-brand="Inventive HQ"
      data-primary-color="#2813e8"
      data-accent-color="#2cc3d1"
      data-schedule-url="https://hs.inventivehq.com/meetings/sean1324/reception"
      data-allowed-paths="/,/about,/contact,/services,/services/*,/industries,/industries/*,/software,/software/*,/lp/*"
      data-excluded-prefixes={EXCLUDED_PREFIXES.join(',')}
      data-require-email="true"
    />
  );
}
